import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import './CSStatus.scss';
import { sortType } from 'src/model/modules/invoices.model';
import InvoiceModel from 'src/model/invoice.model';
import { IPaySimpleError } from 'src/store/modules/paysimplepayment/reducers';
import cmptCSFilterBar from '../CSFilterBar/CSFilterBar';
import CalenderIcon from 'src/assets/calendarIcon';
import CalenderIcon2 from 'src/assets/calendarIcon2';
import CalenderIcon3 from 'src/assets/calendarIcon3';
import PaymentIcon from 'src/assets/payment';
import DollarIcon from 'src/assets/dollar';
// import PaymentMethod from '../PaymentMethod';
import CSFilters from 'src/components/ClaimStatus/components/CSFilters/CSFilters';
import CSDesktop from 'src/components/ClaimStatus/components/CSDesktop/CSDesktop';
import DateRangeModel from 'src/model/dateRange.model';
import * as moment from 'moment';
import {
  ICSSvcFilters,
  ICSSvcPagination
} from 'src/services/claimStatus/claimStatusService';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';
import { IPagination } from 'src/services/paySimple/paySimpleService';
import CSStatusDetails from '../CSStatusDetails/CSStatusDetails';

export default function CSStatus(props: any) {
  const [filtervalues, setfiltervalues] = React.useState();
  const [reset, checkReset] = React.useState(false);
  const [setcResubmitDetails, SetResubmitClaim, IsRClaim] = props;
  // console.log('CS Status Props', props);
  // console.log("CSStatus Props",props);

  const getFilterValues = (dates: any, isHeader?: boolean) => {
    const filters: ICSSvcFilters = {
      dateRange: dates,
      status: null,
      orderStatus: null,
      csSearchKey: null,
      csSearchVal: null,
      sort: null
    };
    const pagination: ICSSvcPagination = {
      page: 0
    };
    // getCSHistory(filters, pagination, isHeader);
  };

  React.useEffect(() => {
    if (IsRClaim) {
      // console.log('ReSubmit Claim');
      // setValue(0);
    }
  }, [IsRClaim]);

  React.useEffect(() => {
    const dtRange = new DateRangeModel();
    dtRange.start = moment().add({ months: -24 });
    dtRange.end = moment();
    getFilterValues(dtRange);
    /*
    if (window.innerWidth > 1023) {
      setOpenFilters(true);
    }
    */
  }, []);

  return (
    <>
      <div className="col-md-12 CS-container">
        <div
          className="mobile-filters"
          style={{ display: 'grid', background: '#f2f2f2' }}
        >
          <CSFilters
            filtervalues={filtervalues}
            setfiltervalues={setfiltervalues}
            checkReset={checkReset}
          />{' '}
        </div>

        <CSDesktop
          filtervalues={filtervalues}
          setfiltervalues={setfiltervalues}
          checkReset={checkReset}
          setcResubmitDetails={props.setcResubmitDetails}
          SetResubmitClaim={props.SetResubmitClaim}
        />
      </div>
    </>
  );
}
// export default CSStatus;
